import classNames from "classnames";
import { PropsWithChildren } from "react";
import { PageWrapperMode } from "../../../enums/page-wrapper-mode.enum";
import { Animate } from "../../animation/animation";
import styles from './page-wrapper.module.scss';

interface PageWrapperProps {
  mode: PageWrapperMode
  active?: boolean
  shrink?: boolean
  shrinkFirst?: boolean
  fullScreenHeight?: boolean;
}

export function PageWrapper({ children, mode, active = true, shrink = false, shrinkFirst = false, fullScreenHeight = true }: PropsWithChildren<PageWrapperProps>) {

  if (shrinkFirst) return <div className={classNames(styles[mode], styles.shrink, { [styles.fullScreenHeight]: fullScreenHeight })}>{children}</div>;
  
  return (<Animate animation="shrink" delay={100} duration={500} when={shrink}>
    <div className={classNames(styles[mode], { [styles.fullScreenHeight]: fullScreenHeight })}>{children}</div>
  </Animate>)
}